// src/views/words-lists/components/BreadcrumbNav.tsx
import React, { FC } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { BreadcrumbItemType } from '../../../services/ApiService';
import styles from '../FolderTreeView.module.less';

interface BreadcrumbNavProps {
  breadcrumbs: BreadcrumbItemType[];
  onBreadcrumbClick: (crumbId: string) => void;
}

export const BreadcrumbNav: FC<BreadcrumbNavProps> = ({
  breadcrumbs,
  onBreadcrumbClick,
}) => (
  <Breadcrumb className={styles.breadcrumbs}>
    {breadcrumbs.map((crumb, index) => {
      const isLast = index === breadcrumbs.length - 1;

      return (
        <Breadcrumb.Item
          key={crumb.id}
          href={!isLast ? '#' : undefined}
          onClick={!isLast ? (e) => {
            e.preventDefault();
            onBreadcrumbClick(crumb.id);
          } : undefined}
        >
          {crumb.id === 'root' && <HomeOutlined />}
          <span className={isLast ? styles.lastBreadcrumb : ''}>
            {crumb.name}
          </span>
        </Breadcrumb.Item>
      );
    })}
  </Breadcrumb>
);
